import ReactDOM from "react-dom";
import App from "./components/App";
import "./index.css";
import AppProvider from "./shared/ContextProvider";
import DataProvider from "./shared/DataProvider";

ReactDOM.render(
  <DataProvider>
    <AppProvider>
      <App />
    </AppProvider>
  </DataProvider>,
  document.getElementById("root")
);
